import logoSrc from "@/assets/img/fivi360_logo.png";
import { cn } from "@/lib/utils";
import {
  BRAND_LOGO_DEFAULT_CLASS,
  BRAND_LOGO_SIZES,
} from "@/components/common/brandTokens";

/**
 * Marca visual FIVI360 (wordmark em imagem).
 *
 * `className` continua sendo a API estável — consumidores existentes
 * que passam `className="h-4"` / `h-7` / etc. não mudam.
 *
 * `size` é opcional e só substitui a altura default quando informado
 * (`sm` | `md`). Não migrar consumidores nesta RC.
 */
export function BrandLogo({
  className,
  alt = "FIVI360",
  testId,
  size,
  ...imgProps
}) {
  const sizeClass = size ? BRAND_LOGO_SIZES[size] : null;

  return (
    <img
      src={logoSrc}
      alt={alt}
      data-testid={testId}
      className={cn(
        sizeClass
          ? `w-auto object-contain ${sizeClass}`
          : BRAND_LOGO_DEFAULT_CLASS,
        className,
      )}
      {...imgProps}
    />
  );
}
